import React from 'react';
import {
  inviteHasPmCncInputAdjustment,
  pmCncInviteInputAdjustedTitle,
  pmQuoteInputAdjustedTitle,
  submissionHasPmQuoteInputAdjustment,
} from '../../utils/rfqPmQuoteInputStamp';
import type { RfqSubmission, TimberSupplierInvite } from '../../types';

export function PmSubmissionQuoteInputAdjustedBadge({
  submission,
}: {
  submission: Pick<
    RfqSubmission,
    'pmQuoteInputAdjustedAt' | 'pmQuoteInputAdjustedByName'
  >;
}) {
  if (!submissionHasPmQuoteInputAdjustment(submission)) return null;
  return (
    <span
      className="srfq-pm-input-adjusted-badge"
      title={pmQuoteInputAdjustedTitle(submission)}
    >
      PM adjusted input
    </span>
  );
}

export function PmCncInviteInputAdjustedBadge({
  invite,
}: {
  invite: Pick<TimberSupplierInvite, 'pmCncInputAdjustedAtIso' | 'pmCncInputAdjustedByName'>;
}) {
  if (!inviteHasPmCncInputAdjustment(invite)) return null;
  return (
    <span
      className="srfq-pm-input-adjusted-badge"
      title={pmCncInviteInputAdjustedTitle(invite)}
    >
      PM adjusted input
    </span>
  );
}
